!((document, Drupal, $) => {
  'use strict';

  Drupal.behaviors.gardenGuide = {
    attach: function(context) {
      $(document).ready(function() {
        const $modal = $('.garden-guide-modal', context);
        const $modalToggleOpen = $('.garden-guide__btn', context);
        const $modalContent = $('.modal-content', $modal);
        const $modalToggleClose = $('.modal-close', $modal);
        const $modalOverlay = $('.modal-overlay', $modal);

        $modalContent.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          prevArrow:
            '<button class="slide-arrow prev-arrow slick-arrow" aria-label="go to previous item"><svg viewBox="0 0 490.688 490.688" aria-hidden="true"><path d="M472.328 120.529L245.213 347.665 18.098 120.529c-4.237-4.093-10.99-3.975-15.083.262-3.992 4.134-3.992 10.687 0 14.82l234.667 234.667c4.165 4.164 10.917 4.164 15.083 0l234.667-234.667c4.237-4.093 4.354-10.845.262-15.083-4.093-4.237-10.845-4.354-15.083-.262-.089.086-.176.173-.262.262l-.021.001z"></path></svg></button>',
          nextArrow:
            '<button class="slide-arrow next-arrow slick-arrow" aria-label="go to next item"><svg viewBox="0 0 490.688 490.688" aria-hidden="true"><path d="M472.328 120.529L245.213 347.665 18.098 120.529c-4.237-4.093-10.99-3.975-15.083.262-3.992 4.134-3.992 10.687 0 14.82l234.667 234.667c4.165 4.164 10.917 4.164 15.083 0l234.667-234.667c4.237-4.093 4.354-10.845.262-15.083-4.093-4.237-10.845-4.354-15.083-.262-.089.086-.176.173-.262.262l-.021.001z"></path></svg></button>'
        });

        $modalToggleOpen.on('click', function(e) {
          e.preventDefault();
          $modalContent.slick('setPosition');
          $modal.addClass('is-visible');
          $('body').addClass('modal-open');
        });

        $modalToggleClose
          .on('click', function() {
            $modal.removeClass('is-visible');
            $('body').removeClass('modal-open');
          })
          .on('keydown', function(e) {
            if (e.keyCode === 32 || e.keyCode === 13) {
              $modal.removeClass('is-visible');
              $('body').removeClass('modal-open');
            }
          });

        $modalOverlay.on('click', function() {
          $modal.removeClass('is-visible');
          $('body').removeClass('modal-open');
        });
      });
    }
  };
})(document, Drupal, jQuery);
